import Accounts from '@/views/accounts/accounts-list/index.vue';
import AccountsDetails from '@/views/accounts/accounts-details/index.vue';
import Conciliation2Details from '@/views/conciliation2/conciliation2-details/index.vue';
import GroupDetails from '@/views/group-details/index.vue';
import IntervenerDetails from '@/views/interveners-details/index.vue';
import IntervenerParticipantAccounts from '@/views/interveners-details/intervener-participant-accounts';
import Interveners from '@/views/interveners-list/index.vue';
import IssueDetails from '@/views/issue-details/index.vue';
import OperationDetails from '@/views/operation-details/index.vue';
import Operations from '@/views/operation-list/index.vue';
import PermissionSetDetails from '@/views/permission-set-details/index.vue';
import RelatedDocumentation from '@/views/shared/related-documentation/index.vue';
import UserDetails from '@/views/users/users-details/index.vue';

export default {
    name: 'dynamic-component',
    components: {
        Accounts,
        AccountsDetails,
        Conciliation2Details,
        GroupDetails,
        IntervenerDetails,
        IntervenerParticipantAccounts,
        Interveners,
        IssueDetails,
        Operations,
        OperationDetails,
        PermissionSetDetails,
        RelatedDocumentation,
        UserDetails
    },
    props: {
        view: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false
        },
        currency: {
            type: String,
            required: false
        },
        product: {
            type: String,
            required: false
        }
    },
    computed: {
        /**
         * Comprueba si está el loader activo
         * @return {Boolean} Estado del loader
         */
        loading() {
            return this.$store.getters['loaderStore/isVisible'];
        }
    }
};
